import { render } from "./schoolNews.vue?vue&type=template&id=18bde52e&scoped=true"
import script from "./schoolNews.vue?vue&type=script&lang=js"
export * from "./schoolNews.vue?vue&type=script&lang=js"

import "./schoolNews.vue?vue&type=style&index=0&id=18bde52e&lang=css"
import "./schoolNews.vue?vue&type=style&index=1&id=18bde52e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bde52e"]])

export default __exports__